import Swiper from "swiper";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export default function swiperPropertyListing() {

    const swipers = document.querySelectorAll(".property-listing__swiper");

    swipers.forEach((swiperElement) => {
        const slidesPerViewDesktop = swiperElement.dataset.slidesPerView ? parseInt(swiperElement.dataset.slidesPerView) : 3;
        const wrapper = swiperElement.closest('.property-listing__swiper-wrapper') || swiperElement.parentElement;

        new Swiper(swiperElement, {    
            modules: [Navigation, Pagination, Scrollbar],

            // Params
            loop: true,
            grabCursor: false,
            speed: 800,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 40,

            // Navigation
            navigation: {
                prevEl: wrapper.querySelector(":scope > .swiper-button-prev"),
                nextEl: wrapper.querySelector(":scope > .swiper-button-next"),
            },

            // Pagination
            // pagination: {
            //     el: ".property-listing__swiper ~ .swiper-pagination",
            //     clickable: true,
            // },

            // Scrollbar
            // scrollbar: {
            //     el: wrapper.querySelector(".swiper-scrollbar"),
            //     draggable: true,
            // },

            breakpoints: {
                998: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: slidesPerViewDesktop,
                },
            },
        })
    });
};
